import React from "react";
import {
  Grid,
  Select,
  MenuItem,
  TextField,
  Typography,
  FormControl,
} from "@mui/material";
import { NumericFormat } from "react-number-format";
import selectAllOnFocus from "./selectAllOnFocus";

const FeeRow = ({
  label,
  fieldKey,
  state = {},
  setState = () => {},
  unitOptions = [
    { el: "%", id: 1 },
    { el: "€", id: 2 },
  ],
  MenuProps,
  disabled = false,
}) => {
  const item = state?.[fieldKey] || {};
  const unitValue = item.idTipoFee ?? "";
  const amountValue = item.fee ?? "";
  const totalRaw = item.totale ?? null;
  const formatter = new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });
  const total =
    totalRaw != null
      ? "€" + formatter.format(Number(totalRaw)).replace("€", "").trim()
      : "€ 0,00";

  const handleUnitChange = (e) => {
    const value = e.target.value;
    setState((prev) => {
      const current = prev?.[fieldKey] || {};
      // If switching to €, set totale equal to fee
      const newTotale = value === 2 ? current.fee : current.totale;
      return {
        ...prev,
        [fieldKey]: { ...current, idTipoFee: value, totale: newTotale },
      };
    });
  };

  const handleAmountChange = (values) => {
    const value = values.floatValue ?? 0;
    setState((prev) => {
      const current = prev?.[fieldKey] || {};
      // If current unit is €, set totale equal to the new fee value
      const newTotale = current.idTipoFee === 2 ? value : current.totale;
      return {
        ...prev,
        [fieldKey]: { ...current, fee: value, totale: newTotale },
      };
    });
  };

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "100%" }}
    >
      {/* Left: label and inputs. On xs label stacks above inputs; on sm+ they are inline */}
      <Grid item xs={6} sm={8} md={6}>
        <Grid
          container
          alignItems="center"
          columns={12}
          direction={{ xs: "column", sm: "row" }}
        >
          <Grid item xs={12} sm={4}>
            <Typography>{label}</Typography>
          </Grid>
          <Grid item xs={6} sm={4} width={"100%"}>
            <FormControl fullWidth>
              <Select
                id={`${fieldKey}/idTipoFee`}
                name={`${fieldKey}/idTipoFee`}
                size="small"
                value={unitValue}
                onChange={handleUnitChange}
                MenuProps={MenuProps}
                disabled={disabled}
              >
                {unitOptions.map((opt) => (
                  <MenuItem key={opt.id} value={opt.id}>
                    {opt.el}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4} width={"100%"}>
            <NumericFormat
              id={`${fieldKey}/fee`}
              name={`${fieldKey}/fee`}
              customInput={TextField}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fullWidth
              disabled={disabled}
              value={amountValue}
              onValueChange={handleAmountChange}
              onFocus={selectAllOnFocus}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* Right: total always aligned right */}
      <Grid item xs={6} sm={4} md={6} sx={{ textAlign: "right" }}>
        <Typography>{total}</Typography>
      </Grid>
    </Grid>
  );
};

export default FeeRow;
